import { z } from "zod";

// Esquema para login
export const loginSchema = z.object({
  usuario: z
    .string()
    .min(3, "El usuario debe tener al menos 3 caracteres")
    .max(50, "El usuario no puede exceder 50 caracteres")
    .regex(/^[a-zA-Z0-9_.-]+$/, "El usuario solo puede contener letras, números, punto, guión y guión bajo"),
  pass: z
    .string()
    .min(6, "La contraseña debe tener al menos 6 caracteres")
    .max(250, "La contraseña no puede exceder 250 caracteres"),
});

export type LoginInput = z.infer<typeof loginSchema>;

// Esquema para crear empleado
export const crearEmpleadoSchema = z.object({
  nombres: z
    .string()
    .min(2, "El nombre debe tener al menos 2 caracteres")
    .max(100, "El nombre no puede exceder 100 caracteres"),
  apellidos: z
    .string()
    .min(2, "Los apellidos deben tener al menos 2 caracteres")
    .max(100, "Los apellidos no pueden exceder 100 caracteres"),
  telefono: z
    .string()
    .length(8, "El teléfono debe tener exactamente 8 dígitos")
    .regex(/^\d+$/, "El teléfono solo puede contener números"),
  correo: z
    .string()
    .email("El correo debe ser válido"),
  dpi: z
    .string()
    .length(13, "El DPI debe tener exactamente 13 dígitosssssssssssssssssssss")
    .regex(/^\d+$/, "El DPI solo puede contener números"),
  idPuesto: z
    .number()
    .int("El puesto debe ser un número entero")
    .positive("El puesto debe ser un número positivo"),
  activo: z.boolean().default(true),
});

export type CrearEmpleadoInput = z.infer<typeof crearEmpleadoSchema>;

// Esquema para actualizar empleado
export const actualizarEmpleadoSchema = crearEmpleadoSchema.partial();

export type ActualizarEmpleadoInput = z.infer<typeof actualizarEmpleadoSchema>;

// Esquema para crear agente
export const crearAgenteSchema = z.object({
  usuario: z
    .string()
    .min(3, "El usuario debe tener al menos 3 caracteres")
    .max(50, "El usuario no puede exceder 50 caracteres"),
  agente: z
    .string()
    .min(3, "El nombre del agente debe tener al menos 3 caracteres")
    .max(50, "El nombre del agente no puede exceder 50 caracteres"),
  nombreNegocio: z
    .string()
    .min(3, "El nombre del negocio debe tener al menos 3 caracteres")
    .max(100, "El nombre del negocio no puede exceder 100 caracteres"),
  propietario: z
    .string()
    .min(3, "El propietario debe tener al menos 3 caracteres")
    .max(100, "El propietario no puede exceder 100 caracteres"),
  ubicacion: z
    .string()
    .min(3, "La ubicación debe tener al menos 3 caracteres")
    .max(100, "La ubicación no puede exceder 100 caracteres"),
  idEmpleado: z
    .number()
    .int("El empleado debe ser un número entero")
    .positive("El empleado debe ser un número positivo"),
});

export type CrearAgenteInput = z.infer<typeof crearAgenteSchema>;

// Esquema para actualizar agente
export const actualizarAgenteSchema = crearAgenteSchema.partial();

export type ActualizarAgenteInput = z.infer<typeof actualizarAgenteSchema>;
